import { BreakableText } from "@design-system/BreakableText/BreakableText";
import React from "react";
import { getSubaccountDisplayName } from "@design-system/Subaccount/utils";
import { SubaccountSchema } from "@common/schemas/subaccount.schema";

interface Props {
    subaccount: Pick<SubaccountSchema, "accountNumber" | "name">;
}

export const Subaccount: React.FC<Props> = ({ subaccount }) => {
    const displayedName = getSubaccountDisplayName(subaccount);

    return <BreakableText text={displayedName} />;
};
